<div class="p-grid">
    <div class="p-col-1">
        <label style="line-height: 2.5;">Filter: </label>
    </div>
    <div class="p-col-3">
        <p-dropdown [options]="allModuleNames" [(ngModel)]="selectedModule" optionLabel="name"
         appendTo="body" (onChange)="changeModule()" class="filterDD">
        </p-dropdown>
    </div>
</div>
<p-table [value]="allSections" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Module</th>
            <th>Template</th>
            <th>Active</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-section>
        <tr>
            <td>{{section.name}}</td>
            <td>{{section.module}}</td>
            <td>{{section.displayName}}</td>
            <td>{{section.isActive?'Yes':'No'}}</td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" *ngIf="!section.systemGenerated"><i class="pi
            pi-pencil" (click)="showEditSection(section)"></i></span>
                <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="!section.systemGenerated" (click)="checkSection(section,'delete')" tooltipPosition="top"><i
                        class="pi pi-trash"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="{{addEditSectionHeader}}" [(visible)]="displaySectionAddEdit" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <form [formGroup]="sectionForm">
        <div class="header">
            <h5>Section Information
                <p-inputSwitch class="header-switch" formControlName="isActive" [disabled]="statusDisabled"></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <label>Name <span style="color: red;">*</span></label>
                    <input pInputText type="text" id="name" formControlName="name"  />
                    <!-- <small *ngIf="invalidData" class="p-invalid">Name already exists.</small> -->
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-6">
                    <label>Module</label>
                    <p-dropdown [options]="allModuleNames" formControlName="moduleId" placeholder="Select Module"
                        optionLabel="name"  [disabled]="!isAddSection" (onChange)="getConfigurationTypes()">
                    </p-dropdown>
                </div>
                <div class="p-col-6">
                    <label>Template</label>
                    <p-dropdown [options]="allTemplates" formControlName="typeId" placeholder="Select Template"
                        optionLabel="displayName"  [disabled]="!isAddSection">
                    </p-dropdown>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displaySectionAddEdit=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton [disabled]="!sectionForm.valid" (click)="saveSection(sectionForm.value)" label="Save"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Delete Section" [(visible)]="displaySectionAvailability" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="header">
    <h5>Delete Warning</h5>
  </div>
  <div class="card">
    <span style="font-weight: bold;">This Section is associated with Multiple Custom Attributes.</span>
  </div>
</p-dialog>